import * as io from 'io-ts';
import { Address } from './Buyer';

export const Location = io.type({
  id: io.string,
  name: io.string,
  merchantID: io.string,
  externalReferenceID: io.string,
  partnerReferenceID: io.string,
  enabled: io.boolean,
  address: Address,
});

export type Location = io.TypeOf<typeof Location>;

export const LocationResponse = io.type({
  location: Location,
});

export type LocationResponse = io.TypeOf<typeof LocationResponse>;
